const meta = {
	layout: 'content',
	module: 'MGC,city',
}

const mundoGamerCity = [
	{
		path: '/network/mundo-gamer-city/districts',
		name: 'network-city-districts-list',
		component: () => import('@/views/network/mundo-gamer-city/districts/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/npcs',
		name: 'network-city-npcs-list',
		component: () => import('@/views/network/mundo-gamer-city/npcs/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/features',
		name: 'network-city-features-list',
		component: () => import('@/views/network/mundo-gamer-city/features/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/missions',
		name: 'network-city-missions-list',
		component: () => import('@/views/network/mundo-gamer-city/missions/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/coin-spawns',
		name: 'network-city-coin-spawns-list',
		component: () => import('@/views/network/mundo-gamer-city/coinSpawns/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/easter-eggs',
		name: 'network-city-easter-eggs-list',
		component: () => import('@/views/network/mundo-gamer-city/easterEggs/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/seasonal-events',
		name: 'network-city-seasonal-events-list',
		component: () => import('@/views/network/mundo-gamer-city/seasonalEvents/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/profiles',
		name: 'network-city-profiles-list',
		component: () => import('@/views/network/mundo-gamer-city/profiles/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/dialogues',
		name: 'network-city-dialogues-list',
		component: () => import('@/views/network/mundo-gamer-city/dialogues/list.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/dialogues/:id/editor',
		name: 'network-city-dialogue-editor',
		component: () => import('@/views/network/mundo-gamer-city/dialogues/dialogueEditor.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/texts',
		name: 'network-city-texts-list',
		component: () => import('@/views/network/mundo-gamer-city/texts.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/analytics',
		name: 'network-city-analytics',
		component: () => import('@/views/network/mundo-gamer-city/analytics/dashboard.vue'),
		meta,
	},
	{
		path: '/network/mundo-gamer-city/settings',
		name: 'network-city-settings',
		component: () => import('@/views/network/mundo-gamer-city/settings.vue'),
		meta,
	},
]

export default mundoGamerCity
